const APP_DASHBOARD = '/dashboard';
const APP_EXISTING_DASHBOARD = '/dashboard';
const GET_EXISTING_USER_PAGE = 'api/project-module/web-user-dashboard/';
export { APP_DASHBOARD, APP_EXISTING_DASHBOARD, GET_EXISTING_USER_PAGE };
